let isSpecial = false
if (window.innerWidth <= 1200 && window.innerWidth > 999) {
  isSpecial = true
}
export default isSpecial
